/* eslint-disable max-len */
export default {
    atol: {
        title: 'Атол',
        changeStatusColumns: ['Номер заказа', 'Тип операции'],
        changeStatusButton: 'Отправить',
        viewBill: 'Просмотр чеков',
        view: 'Просмотр',
        link: 'Ссылка',
        waitStatus: 'Ожидание...',
        refundNumberSAP: 'Номер возврата SAP',

        list: {
            type: 'Тип чека',
            total: 'Сумма, р',
            date: 'Дата',
            link: 'Ссылка на чек',
        },
    },

    setKit: {
        title: 'SetKit',
        count: 'Найден {count} кассовый чек | Найдено {count} кассовых чека | Найдено {count} кассовых чеков',
        view: 'Просмотр мягких чеков',
        empty: 'По заказу {orderId} чеки не найдены!',
        addFch: {
            title: 'Добавление ФЧ',
            button: 'Добавить ФЧ',
            listTitle: 'Список фактических чеков',
            searchPlaceholder: 'Поиск по номеру заказа',
            orderId: 'Номер заказа',
            guid: 'Номер ФЧ',
            dateCreated: 'Дата ФЧ',
            orderNotFound: 'Заказ не найден',
            modal: {
                title: 'Заказ №{orderId}',
                templatesPlaceholder: 'Шаблоны ФЧ',
                templatePoints: 'Списание баллов',
                templatePromocode: 'Применён промокод',
                addProduct: '+ Добавить товар',
                uploadFch: 'Загрузить ФЧ',
                uploadSuccess: 'ФЧ успешно загружен',
                errorInvalidData: 'Некорректные данные в запросе',
                errorAlreadyExists: 'По данному заказу уже есть ФЧ',
                errorEmptyBody: 'Отсутствует тело запроса',
            },
        },
    },

    mailing: {
        add: {
            title: 'Добавить получателя',
            warning: ['Не заполнен email', 'Такой получатель уже существует'],
            placeholder: 'Введите email',
            button: 'Добавить',
        },

        'delete': 'Вы уверены что хотите удалить получателя рассылок?',

        index: {
            title: 'Получатели',
            message: 'Не удалось получить список рассылок',
        },

        typeList: {
            title: 'Рассылки получателя',
            messages: [
                'Не удалось получить список рассылок',
                'Не удалось изменить список рассылок',
            ],
        },
    },

    roles: {
        main: {
            orderStatuses: {
                title: 'Настройка разделов списка заказов',
                lead:
          'Заказы с какими статусами будут располагаться в разделах списка заказов в зависимости от роли пользователя',
            },
            permissions: {
                title: 'Доступы',
                lead: 'Просмотр доступов для ролей',
            },
        },

        orderStatus: {
            button: 'Сохранить изменения',
            sections: [
                'Неиспользуемые',
                'В работе',
                'Завершённые',
                'Новые',
            ],
            message: 'Не удалось получить связи между разделами и статусами заказа',
        },

        roleButton: 'Не удалось получить список ролей',
    },

    sap: {
        hold: {
            columns: ['Номер заказа', 'Дата', 'Тип'],
            button: 'Отправить',
            alert: 'При расхолдировании дата проводки должна быть равна дате проводки холдирования',
        },

        index: ['Проводки', 'Холдирование'],

        sendWiring: 'Отправить проводку',
        bulkSending: 'Массовая отправка',

        loader: {
            title: 'Загрузить файл',
            subtitle: 'Массовая отправка проводок в SAP на основе данных из файла',
            fileNotSelected: 'Файл не выбран',
            chooseFile: 'Выберите файл',
            downloadTemplate: 'Скачать шаблон {link} для заполнения',
            xlsxFile: '.xlsx-файла',
            invalidFileType: 'Недопустимый тип файла',
        },

        list: {
            title: 'Задания на массовую отправку проводок',
            empty: 'Нет актуальных заданий на массовую отправку проводок',
            id: 'ID',
            numberOfLines: 'Кол-во строк',
            initiator: 'Инициатор',
            dateOfCreation: 'Дата создания',
            dateOfUpdate: 'Дата обновления',
            status: 'Статус',
            inProgress: 'В обработке',
            error: 'Ошибка',
            done: 'Выполнено',
        },

        taskDetails: {
            id: 'ID',
            status: 'Статус',
            orderId: 'Номер заказа',
            date: 'Дата проводки',
            type: 'Вид проводки',
            message: 'Детали',
            back: 'Назад',
        },

        transaction: {
            columns: [
                'Номер заказа',
                'Дата',
                'Тип операции',
                'Тип события',
                'Сторнировать проводку',
            ],
            button: 'Отправить',
            warehouse: 'Склад',
            factory: 'Завод',
            hintRequiredField: 'Обязательное поле, длина от 3 до 4 символов',
        },
    },

    reports: {
        typeReports: 'Тип отчета',
        selectPeriod: 'Задайте период',
        unload: 'Выгрузить',
        types: {
            wiring: 'Отчет по товарам в движении по заказам доставки',
        },
    },

    main: {
        test: {
            title: 'Тестовый заказ',
            lead: 'Работа с тестовыми заказами',
        },

        orderChangeStatus: {
            title: 'Изменение статуса заказа',
            lead: 'Перейти к изменению статуса заказа',
        },

        externalServices: {
            title: 'Включение сервисов',
            lead: 'Включение и отключение сторонних сервисов',
            modal: 'Включение/Отключение сервисов',
        },

        roles: {
            title: 'Настройка ролей',
            lead: 'Настройка параметров ролей',
        },

        mailing: {
            title: 'Рассылки',
            lead: 'Администрирование получателей почтовых рассылок',
        },

        events: {
            title: 'Управление событиями',
            lead:
        'Просмотр не отработавших событий и их дальнейший перезапуск либо отмена',
        },

        sap: {
            title: 'SAP',
            lead: 'Отправки запросов в SAP',
        },

        acceptanceActs: {
            title: 'АПП',
            lead: 'История актов приема-передачи',
        },

        check: {
            title: 'Чеки',
            lead: 'Отправка чеков Просмотр чеков Просмотр мягких чеков',
        },

        distribution: {
            title: 'Распределение заказов',
            lead: 'Распределение заказов',
        },

        reports: {
            title: 'Отчеты',
            lead: 'Формирование отчетных документов',
        },

        tracknumSearch: {
            title: 'Поиск заказов',
            lead: 'Поиск заказов по трек номеру',
        },

        ui: {
            title: 'Настройка интерфейса',
            lead: 'Регулирование отображения блоков',
            priority: 'Страница Заказы',
            expired: 'Приоритетность сборки',
            expiredTitle: 'Категории',
            priorityTitle: 'Управление категориями',
            save: 'Сохранить изменения',
            cancel: 'Отмена',
            alert: 'На данной странице задается плановый срок выполнения задач с типом "Формирование заказа" и "Формирование заказа в доставку" в минутах. Вы можете ввести значение в диапазоне от {min} до {max} минут.\nВНИМАНИЕ! Настройки применятся только для новых заказов, созданных после сохранения изменений!',
            modal: {
                save: {
                    title: 'Внимание!',
                    text: 'Сохранить изменения?',
                },
                cancel: {
                    title: 'Внимание!',
                    text: 'Отменить изменения?',
                },
            },
        },
        reference: {
            title: 'Настройка справочных ссылок',
            lead: 'Настройки соответствия раздела CRM',
            alert: 'На данной странице необходимо сопоставить разделы CRM и ссылки на справочные ресурсы, по которым будет производиться переход при нажатии на кнопку Помощь',
            fields: {
                section: 'Раздел',
                link: 'Ссылка',
                path: 'Ссылка раздела',
            },
            modal: {
                title: 'Внимание!',
                text: 'Подтвердите редактирование справочных ссылок. Изменения откатить нельзя!',
            },
        },

        alerts: {
            title: 'Алерты',
            lead: 'Список заказов, требующих внимания по бизнес-процессам',
        },
    },

    orderChange: {
        placeholder: 'Номер заказа',
        invalidFeedback: 'Заказ не найден!',
        title: 'Заказ № {order} от {date}',
        p: 'Статус:',
        label: 'Новый статус',
        button: 'Изменить статус',
        search: 'Найти',
        changeStatus: 'Статус успешно изменен',
        factory: 'Завод',
        warehouse: 'Склад',
        hintFieldLength: 'Поле состоит из 3-4 символов',
        hintFieldIsNotFilled: 'Поле не заполнено',
    },

    distribution: {
        enable: 'Включить функционал распределения заказов',
        overloadPfm: 'Учитывать загрузку ПФМ',
        limit: 'Лимит загрузки заказов в статусе "К формированию" склада C001',
        percent: 'Выбирать ПФМ, у которых % товаров из заказа в наличии не меньше',
        percentPlaceholder: 'Лимит',
        pfmTitle: 'ПФМ для распределения заказов',
        addPfm: 'Добавить ПФМ',
        ifPfm: 'Если ни один ПФМ не подходит, то',
        save: 'Применить',
        moscow: 'C001',
        otherPfm: 'Другие ПФМ',
        basePfm: 'Базовые ПФМ',
        selectPfm: 'Выбор ПФМ',
        pfmControlTitle: 'Управление базовыми ПФМ',
        addBasePfm: 'Добавить базовый ПФМ',
        incorrectPfm: 'Неверный номер ПФМ',
        list: {
            enable: 'Включить | Отключить',
            warning: 'Номер ПФМ уже есть в таблице!',
            comment: 'минимум - 3, максимум - 4 символа',
            title: 'Подтвердите удаление ПФМ',
            save: 'Сохранить',
            'delete': 'Удалить',
            cancel: 'Отмена',
            pfm: 'ПФМ',
            buttons: 'Управление',
            limit: 'Лимит загрузки',
        },
    },

    tracknumSearch: {
        invalidFeedback: 'По введенному трек-номеру ничего не найдено',
        title: 'Заказ №{orderId}',
        orderId: 'Заказ №',
        deliveryTrack: 'Трек-номер',
        deliveryService: 'Способ доставки',
        orderStatus: 'Статус заказа',
        deliveryStatus: 'Статус доставки',
        orderCard: 'Карточка заказа',
        search: 'Поиск',
        rpo: {
            title: 'РПО Почта РФ',
            subtitle: 'Выгрузка трек-номеров Почта.РФ по номерам заказов',
            fileNotSelected: 'Файл не выбран',
            chooseFile: 'Выберите файл',
            downloadTemplate: 'Скачать шаблон {link} для заполнения',
            cvsFile: '.csv-файла',
            download: 'Скачать',
            fileProcessedSuccessfully: 'Файл успешно обработан, нажмите кнопку «Скачать»',
            reset: 'Сбросить',
        },
    },
    externalServiceAlert: 'Внимание! Отключение сервисов может негативно сказаться на работе системы.',
    testOrderAlert: 'Внимание! Изменение статуса оплаты тестового заказа может привести к созданию реальных чеков и проводок.',
};